import React, { useEffect, useState } from "react";
import OneIcon from "../../Images/oneIcon.svg";
import checkGreen from "../../Images/preCheck/checkGreen.svg";
import checkRed from "../../Images/preCheck/checkRed.svg";
import GreenTick from "../../Images/preCheck/GreenTick.svg";
import RedTick from "../../Images/preCheck/RedTick.svg";
import LoadingSpinner from "../Lottie/LoadingSpinner";
import MessageA1i from "./MessageA1i";
import MessageAY3 from "./MessageAY3";
import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import MessageA13i from "./MessageA13i";

const MessageA26LLMf = (props) => {
    const { scrollToBottom, item, addMessages, setisSubscriber, array ,showMaximumChat} = props;
    let llmRes = item?.LLM;

    const [onChecked, setOnChecked] = useState(false);
    const [isPassed, setIsPassed] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isToggled, setIsToggled] = useState(false);



  const handleToggle = () => {
    setIsToggled(!isToggled)
    
  };

    useEffect(() => {
        const allPassed = item?.checks?.some(check => check.passed === true);
        setIsPassed(!allPassed);

        setLoader(true);
        setOnChecked(true);
        setLoader(false);
    }, []);

    useEffect(() => {
        // scrollToBottom();
    }, [loader]);

    return (
        <div>
            <div style={{ padding: "8px" }} className="header-prob">
                Checklist
            </div>
            <div className="channel-list">
                <div style={{ borderRadius: "8px" }} className="list-of-channels">
                    <div
                        style={{
                            border: onChecked ? `1px solid ${!isPassed ? '#43BF5E' : '#B1350C'}` : "1px solid #ccc",
                            backgroundColor: onChecked ? `${!isPassed ? '#EAF8ED' : '#FEF0EB'}` : "#fff",
                            borderBottom: onChecked ? "none" : "1px solid #ccc",
                            height: "64px",
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            borderRadius: onChecked ? "10px 10px 0px 0px" : "10px",
                            cursor: "pointer",
                        }}
                        className="precheck-header"
                    >
                        <img
                            src={!isPassed && !loader ? GreenTick : RedTick}
                            style={{
                                height: "clamp(32px, 4vw, 72px)",
                                width: "clamp(16px, 4vw, 32px)",
                            }}
                            alt="Icon"
                        />
                        <div>Prechecks</div>
                    </div>

                    {/* Smooth expanding section without fixed height */}
                    <div
                        style={{
                            height: 'auto',
                            opacity: onChecked ? 1 : 0,
                            overflow: "hidden",
                            borderRadius: "10px",
                            border: onChecked ? `1px solid ${!isPassed ? '#43BF5E' : '#B1350C'}` : "none",
                            backgroundColor: "#fff",
                            transition: "height 0.8s ease, opacity 0.8s ease, transform 0.8s ease",
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            position: 'relative',
                            transform: onChecked ? "translateY(0)" : "translateY(20px)",  // Adds upward transition when opening/closing
                            bottom: '10px',
                        }}
                        className="precheck-header"
                    >
                        {onChecked &&
                                    item?.checks?.filter((checkItem) => checkItem?.passed === true) // Filter for passed checks
                                        .map((checkItem, index) => (
                                            <div
                                                key={index}
                                                id={`check-${index}`}
                                                style={{
                                                    margin: "10px 10px 10px 0px",
                                                    display: "flex",
                                                    gap: "10px",
                                                    transition: "opacity 1s ease, transform 1s ease", // Apply smooth fade-in/out and movement
                                                }}
                                            >
                                                <img
                                                    style={{ width: "16px" }}
                                                    src={checkGreen} // Since only passed checks are shown, use the green check icon
                                                    alt="Check Icon"
                                                />
                                                <span className="precheck-flow-font">{checkItem?.preChecks}</span>
                                            </div>
                                        ))}

                    </div>
                   {!loader && !isPassed && llmRes?.response_1 && <div style={{ display: 'flex', marginTop: '4px', alignItems: 'center' }}>
                        <div style={{ fontWeight: '700' }}>Resolution :</div>
                        <img
                            style={{ height: '26px', width: '24px', top: showMaximumChat ? '' : '-15px', marginLeft: '6px' }}
                            key={'plus'}
                            src={isToggled ? iconMinus : iconPlus}
                            onClick={() => handleToggle()}
                        />
                    </div>}
                    {/* {!loader && isToggled && llmRes?.response_1[0]?.title && (
                        <div style={{marginTop : '20px' , marginBottom : '20px'}}>
                            <span style={{ fontWeight: "700" }}>Title:</span>
                            <span
                                style={{ marginLeft: "4px" }}
                                className="A3f"
                                dangerouslySetInnerHTML={{ __html: llmRes?.response[0]?.title || "" }}
                            />
                        </div>


                    )}
                    {!loader && isToggled && llmRes?.response_1[0]?.summary && (
                        <div
                            style={{ marginLeft: '4px' }}
                            className="A3f"
                            dangerouslySetInnerHTML={{ __html: llmRes?.response_1[0]?.summary }}
                        />
                    )} */}

{!loader && isToggled && Array.isArray(llmRes?.response_1) && llmRes.response_1.map((item, index) => (
    <div
        key={index}
        style={{
            backgroundColor: '#fff',
            border: '1px solid black',
            borderRadius: '12px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.06)',
            padding: '14px',
            // marginBottom: '20px',
            marginTop : '10px',
            transition: 'transform 0.2s ease-in-out',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.01)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    >
        {item?.title && (
            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    fontWeight: '600',
                    marginBottom: '4px',
                }}>
                    Title:
                </div>
                <div
                    dangerouslySetInnerHTML={{ __html: item?.title }}
                />
            </div>
        )}
        {item?.summary && (
            <div>
                <div style={{
                    fontWeight: '600',
                    marginBottom: '4px',
                }}>
                    Summary:
                </div>
                <div
                    className='A3f html-sanitizer'
                    dangerouslySetInnerHTML={{ __html: item?.summary }}
                />
            </div>
        )}
    </div>
))}



                </div>

                {loader && <LoadingSpinner />}
                {/* {!loader && isToggled && <div style={{ marginLeft: '4px' }} className="A3f">{llmRes?.response}</div>} */}
                {!loader && array?.map((arrayItem, index) => (
                    <React.Fragment key={arrayItem?.id || index}>
                        {arrayItem?.uiCommand === "AY3" && (
                            <div style={{ marginTop: '36px' }}>
                                <MessageAY3
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                            </div>
                        )}
                        {(arrayItem?.uiCommand === "A1i") && (
                            <div style={{ display: "inline-block" }}>
                                <MessageA1i
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                            </div>
                        )}
                        {(arrayItem?.uiCommand === "A13i") && (
                                <MessageA13i
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                        )}
                    </React.Fragment>
                ))}

                {/* {loader && <MessageA1i addMessages={addMessages} item={item} setisSubscriber={setisSubscriber} />} */}
            </div>
        </div>
    );
};

export default MessageA26LLMf;
